/* eslint-disable no-shadow */
const state = {
  courseData: {},
  selectedCourse: {}
};

const getters = {
  getCourseData: state => state.courseData,
  getSelectedCourse: state => state.selectedCourse
};

const mutations = {
  setCourseDataMutation: (state, payload) => {
    state.courseData = payload;
  },
  setSelectedCourseMutation: (state, payload) => {
    state.selectedCourse = payload;
  }
};

const actions = {
  setCourseData: ({ commit }, payload) => {
    commit("setCourseDataMutation", payload);
  },
  setSelectedCourse: ({ commit }, payload) => {
    commit("setSelectedCourseMutation", payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
